export var Types;
(function (Types) {
    Types["NEW_MESSAGE"] = "NEW_MESSAGE";
    Types["CLEAR_MESSAGE"] = "CLEAR_MESSAGE";
    Types["RESET_MESSAGE"] = "RESET_MESSAGE";
    Types["IS_TIMEDOUT"] = "IS_TIMEDOUT";
    Types["START_TIMEOUT"] = "START_TIMEOUT";
    Types["RESET_TIMEOUT"] = "RESET_TIMEOUT";
    Types["UPDATE_TIMEOUT"] = "UPDATE_TIMEOUT";
    Types["START_BOT_TYPING"] = "START_BOT_TYPING";
    Types["STOP_BOT_TYPING"] = "STOP_BOT_TYPING";
    Types["PASS_MESSAGE_TO_BOT"] = "PASS_MESSAGE_TO_BOT";
    Types["NEXT_SMART_STATE"] = "NEXT_SMART_STATE";
    Types["UPDATE_PHONE_NUMBER"] = "UPDATE_PHONE_NUMBER";
    Types["UPDATE_EMAIL"] = "UPDATE_EMAIL";
    Types["UPDATE_FIRST_NAME"] = "UPDATE_FIRST_NAME";
    Types["UPDATE_CODE"] = "UPDATE_CODE";
    Types["SHOW_CONTANT_US"] = "SHOW_CONTANT_US";
    Types["HIDE_CONTANT_US"] = "HIDE_CONTANT_US";
    Types["SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR"] = "SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR";
    Types["SHOW_FATAL_ERROR_PAGE"] = "SHOW_FATAL_ERROR_PAGE";
    Types["HIDE_FATAL_ERROR_PAGE"] = "HIDE_FATAL_ERROR_PAGE";
    Types["SHOW_SEND_CODE_ACTION"] = "SHOW_SEND_CODE_ACTION";
    Types["HIDE_SEND_CODE_ACTION"] = "HIDE_SEND_CODE_ACTION";
    Types["SHOW_CHANGE_PHONE_ACTION"] = "SHOW_CHANGE_PHONE_ACTION";
    Types["HIDE_CHANGE_PHONE_ACTION"] = "HIDE_CHANGE_PHONE_ACTION";
    Types["SAVE_LEADS"] = "SAVE_LEADS";
    Types["NEXT_EXPERIMENT_ONE_SMART_STATE"] = "NEXT_EXPERIMENT_ONE_SMART_STATE";
    Types["SIGN_IN_SUBMITTED"] = "SIGN_IN_SUBMITTED";
    Types["START_STEP_BUTTON_CLICKED"] = "START_STEP_BUTTON_CLICKED";
})(Types || (Types = {}));
//# sourceMappingURL=index.js.map